import { ADLImpact, MobilityScore, RadiologicalSeverity, PainScore, reverseEnum, ValueMappings } from "../../enum";
import BooleanDisplay from "../misc/BooleanDisplay";

const OtherTable = ({patientDetails, operationDetails, isEditing, editedOperation, handleEditChange}) => {
  
      // again, these are TEMP. when the backend returns only strings to the frontend, these maps can be removed
      // erm actually these are permanent (but there's now a centralised way) 🤓☝️
    const painScoreLabel = ValueMappings.painLevel[operationDetails.painLevel] || "N/A";
    const mobilityScoreLabel = ValueMappings.mobility[operationDetails.mobility] || "N/A";
    const radiologicalSeverityLabel = ValueMappings.radioSeverity[operationDetails.radioSeverity] || "N/A";
    const adlImpactLabel = ValueMappings.adl[operationDetails.adl] || "N/A";
    
    return (
        <table className="other-table">
        <thead>
          <tr>
            <th> SIMD </th>
            <th> Months Waited </th>
            <th> Pain Score </th>
            <th> Radiological Severity </th>
            <th> ADL Impact </th>
            <th> Mobility Level </th>
            <th> NTC Attendance </th>
            <th> Work or Care Impairment </th>
            <th> Severe Mental Health Impairment </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{patientDetails.simd.decile}</td>

            <td>{operationDetails.waitingMonths || "N/A"}</td>

            
            <td>
              {isEditing ? (
                <select
                  name="painLevel"
                  value={editedOperation?.painLevel ?? reverseEnum(PainScore)?.[operationDetails?.painLevel] ?? ""}
                  onChange={handleEditChange}
                >
                  <option value="Minimal">Minimal</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Extreme">Extreme</option>
                </select>
              ) : (
                painScoreLabel || "N/A"
              )}
            </td>

            <td>
              {isEditing ? (
                <select
                  name="radioSeverity"
                  value={editedOperation?.radioSeverity ?? reverseEnum(RadiologicalSeverity)?.[operationDetails?.radioSeverity] ?? ""}
                  onChange={handleEditChange}
                >
                  <option value="AsExpected">As expected</option>
                  <option value="LikelihoodOfHarm">Likelihood of harm with delay</option>
                  <option value="RiskOfHarm">Risk of harm with delay</option>
                </select>
              ) : (
                radiologicalSeverityLabel || "N/A"
              )}
            </td>            
            
            <td>
              {isEditing ? (
                <select
                  name="adl"
                  value={editedOperation?.adl ?? reverseEnum(ADLImpact)[operationDetails?.adl] ?? ""}
                  onChange={handleEditChange}
                >
                  <option value="NoneToModerate">None to moderate</option>
                  <option value="UnableToPerform">Unable to perform</option>
                </select>
              ) : (
                adlImpactLabel || "N/A"
              )}
            </td>

            <td>
              {isEditing ? (
                <select
                  name="mobility"
                  value={editedOperation?.mobility ?? reverseEnum(MobilityScore)[operationDetails?.mobility] ?? ""}
                  onChange={handleEditChange}
                >
                  <option value="MinimalLoss">Minimal Loss</option>
                  <option value="ModerateLoss">Moderate Loss</option>
                  <option value="CompleteLoss">Complete Loss</option>
                </select>
              ) : (
                mobilityScoreLabel || "N/A"
              )}
            </td>

            <td>
              {isEditing ? (
                <select
                  name="ntcAttendance"
                  value={(editedOperation?.ntcAttendance ?? operationDetails?.ntcAttendance) ? "true" : "false"}
                  onChange={(e) =>
                    handleEditChange({
                      target: {
                        name: "ntcAttendance",
                        value: e.target.value === "true",
                      },
                    })
                  }
                >
                  <option value="true">✔</option>
                  <option value="false">✗</option>
                </select>
              ) : (
                <BooleanDisplay value={operationDetails?.ntcAttendance} />
              )}
            </td>


            <td>
              {isEditing ? (
                <select
                  name="workOrCareImpairment"
                  value={(editedOperation?.workOrCareImpairment ?? operationDetails?.workOrCareImpairment) ? "true" : "false"}
                  onChange={(e) =>
                    handleEditChange({
                      target: {
                        name: "workOrCareImpairment",
                        value: e.target.value === "true",
                      },
                    })
                  }
                >
                  <option value="true">✔</option>
                  <option value="false">✗</option>
                </select>
              ) : (
                <BooleanDisplay value={operationDetails?.workOrCareImpairment} />
              )}
            </td>


            <td>
              {isEditing ? (
                <select
                  name="mentalHealthImpairment"
                  value={(editedOperation?.mentalHealthImpairment ?? operationDetails?.mentalHealthImpairment) ? "true" : "false"}
                  onChange={(e) =>
                    handleEditChange({
                      target: {
                        name: "mentalHealthImpairment",
                        value: e.target.value === "true",
                      },
                    })
                  }
                >
                  <option value="true">✔</option>
                  <option value="false">✗</option>
                </select>
              ) : (
                <BooleanDisplay value={operationDetails?.mentalHealthImpairment} />
              )}
            </td>
          </tr>
        </tbody>
      </table>
    )

}

export default OtherTable; 